import { useI18n } from '../../i18n'
import type { BlockType } from '../../types'
import {
  Star, Layers, Building2, Briefcase, DollarSign, HelpCircle,
  Phone, MessageSquare, Megaphone, BarChart3, Users, Clock,
  Image, UtensilsCrossed, Shield, Puzzle,
} from 'lucide-react'

interface BlockDef {
  type: BlockType
  icon: typeof Star
  labelZh: string
  labelEn: string
}

const blockDefs: BlockDef[] = [
  { type: 'hero', icon: Star, labelZh: '首屏横幅', labelEn: 'Hero Banner' },
  { type: 'features', icon: Layers, labelZh: '特性展示', labelEn: 'Features' },
  { type: 'about', icon: Building2, labelZh: '关于我们', labelEn: 'About Us' },
  { type: 'services', icon: Briefcase, labelZh: '服务项目', labelEn: 'Services' },
  { type: 'pricing', icon: DollarSign, labelZh: '价格方案', labelEn: 'Pricing' },
  { type: 'faq', icon: HelpCircle, labelZh: '常见问题', labelEn: 'FAQ' },
  { type: 'contact', icon: Phone, labelZh: '联系方式', labelEn: 'Contact' },
  { type: 'testimonials', icon: MessageSquare, labelZh: '客户评价', labelEn: 'Testimonials' },
  { type: 'cta', icon: Megaphone, labelZh: '行动号召', labelEn: 'Call to Action' },
  { type: 'stats', icon: BarChart3, labelZh: '数据统计', labelEn: 'Statistics' },
  { type: 'team', icon: Users, labelZh: '团队成员', labelEn: 'Team' },
  { type: 'timeline', icon: Clock, labelZh: '发展历程', labelEn: 'Timeline' },
  { type: 'gallery', icon: Image, labelZh: '图片画廊', labelEn: 'Gallery' },
  { type: 'menu', icon: UtensilsCrossed, labelZh: '菜单列表', labelEn: 'Menu' },
  { type: 'compliance', icon: Shield, labelZh: '合规资质', labelEn: 'Compliance' },
  { type: 'custom', icon: Puzzle, labelZh: '自定义区块', labelEn: 'Custom Block' },
]

interface BlockLibraryProps {
  onAddBlock: (type: BlockType) => void
  adding?: boolean
}

export default function BlockLibrary({ onAddBlock, adding }: BlockLibraryProps) {
  const { lang, t } = useI18n()

  return (
    <div className="p-4">
      <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
        {t('区块库', 'Block Library')}
      </h3>
      <p className="text-[11px] text-gray-300 mb-4">
        {t('点击添加区块到当前页面', 'Click to add a block to the current page')}
      </p>
      <div className="grid grid-cols-2 gap-2">
        {blockDefs.map(def => (
          <button key={def.type}
            disabled={adding}
            onClick={() => onAddBlock(def.type)}
            className="group flex flex-col items-center gap-1.5 p-3 rounded-xl border border-gray-100 bg-white hover:border-orange-200 hover:bg-orange-50/30 transition-all duration-200 disabled:opacity-50 disabled:cursor-wait">
            <div className="h-8 w-8 rounded-lg bg-gray-50 group-hover:bg-orange-100 flex items-center justify-center transition-colors">
              <def.icon className="h-4 w-4 text-gray-400 group-hover:text-orange-500 transition-colors" />
            </div>
            <span className="text-[11px] text-gray-500 group-hover:text-orange-600 font-medium transition-colors">
              {lang === 'zh' ? def.labelZh : def.labelEn}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
